import { configureStore } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { Modules } from '../modules/_definition/types';
import { reducer as fahrzeugsucheReducer } from './slices/Fahrzeugsuche';
import { type FluxStoreModuleContent } from './types';

export const store = configureStore<Record<Modules.Fahrzeugsuche, FluxStoreModuleContent>>({
    reducer: {
        [Modules.Fahrzeugsuche]: fahrzeugsucheReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export function useAppDispatch() {
    return useDispatch<AppDispatch>();
}
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
